// tslint:disable
export enum TCSGileadCommOption {
    /**
     * @description Opt-In
     */
    OptIn = 0,
    /**
     * @description Opt-Out
     */
    OptOut = 1,
}
(TCSGileadCommOption as any)['OPTIN'] = 0;
(TCSGileadCommOption as any)['OPTOUT'] = 1;
